var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-input-number',{key:_vm.rowKey,style:(_vm.inputStyle),attrs:{"type":"number"},model:{value:(_vm.goldVal),callback:function ($$v) {_vm.goldVal=$$v},expression:"goldVal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }